import { Controller } from "@hotwired/stimulus"

// Auto-loads the next page of a paginated turbo-frame list. When the "Show
// more" link nears the viewport, click it once; the link's target frame is
// replaced with the next page (rows + a fresh foot carrying its own
// controller instance), so each instance fires at most once. Degrades to a
// normal clickable link when IntersectionObserver is unavailable.
export default class extends Controller {
    static targets = ["link"]

    connect() {
        if (!("IntersectionObserver" in window) || !this.hasLinkTarget) return

        this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadMore()
        }, { rootMargin: "600px" })
        this.observer.observe(this.linkTarget)
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
    }

    loadMore() {
        if (this.loaded) return
        this.loaded = true
        this.observer.disconnect()
        this.linkTarget.click()
    }
}
